import React from 'react';

const LoadingSpinner = ({ size = 'md', color = 'primary', text = 'Loading...' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  const colorClasses = {
    primary: 'text-green-600',
    secondary: 'text-gray-600',
    tan: 'text-amber-600',
    dark: 'text-gray-800',
    danger: 'text-red-600',
    success: 'text-green-600'
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      {/* Modern Spinner */}
      <div className="relative">
        <div className={`${sizeClasses[size]} ${colorClasses[color]} animate-spin`}>
          <svg className="w-full h-full" fill="none" viewBox="0 0 24 24">
            <circle 
              className="opacity-20" 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="2"
            />
            <path 
              className="opacity-80" 
              fill="currentColor" 
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
        
        {/* Modern pulse effect */}
        <div className={`absolute inset-0 ${sizeClasses[size]} ${colorClasses[color]} opacity-30 animate-ping`}>
          <div className="w-full h-full rounded-full border-2 border-current"></div>
        </div>
      </div>
      
      {text && (
        <div className="mt-6 text-center">
          <p className="text-lg font-medium text-gray-800 mb-2">{text}</p>
          <div className="flex space-x-1 justify-center">
            <div className="w-2 h-2 bg-green-600 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-green-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-green-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner; 